import { LeaseAgreementCategory } from './const/enums';
import { Contract } from './contract';

export class BlockContract extends Contract {
  constructor() {
    super(LeaseAgreementCategory.Block);
  }
}
